module.exports = __webpack_public_path__ + "img/ck.5503398d.svg";